export default __webpack_public_path__ + "static/media/time-management-circle.7c4403dc.webp";